"use client";

import { useEffect, useState } from "react";

const checkIsMobile = (userAgent: string): boolean => {
  return /android.+mobile|ip(hone|[oa]d)/i.test(userAgent);
};

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Client-side detection
    const userAgent = window.navigator.userAgent;
    setIsMobile(checkIsMobile(userAgent));
  }, []);

  return isMobile;
};
